module.exports = __webpack_public_path__ + "media/images/icons/SVG/051-dfac3916990d60a195c76b4703568428.svg";